import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MainMenuComponent} from './main-menu.component';

@Component({
    selector:        'main-menu-dummy',
    templateUrl:     './main-menu-dummy.component.html',
    styleUrls:       [
        './main-menu.component.scss',
        './main-menu-dummy.component.scss'
    ],
    standalone:      false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainMenuDummyComponent extends MainMenuComponent {

    public override openDropdown(): void {
        // Do nothing
    }

}
